import { ref } from 'vue';
import Cookies from 'js-cookie'

import { getAbTest, ResponseAbTest, CampaignProps } from '@/api/abTest'

const COOKIE_NAME = 'overtax-ab-test'

export const enum TestKey {
  // 메타 유입 후 카카오 로그인 시 인앱브라우저 탈출 실험
  '2505_meta_inapp' = '2505_meta_inapp',
  // 복식부기 대상자 전환 실험
  'doubleentry_effectivetaxrate_250402'= 'doubleentry_effectivetaxrate_250402',
  // 환급금액 상세내역 보고서
  'refund_amount_detail_report_250404' = 'refund_amount_detail_report_250404',
  // 인증 완료 페이지 스킵
  'skip_cert_complete_page_250513' = 'skip_cert_complete_page_250513',
  // 간단 계약서 테스트
  'simple_contract_sp85' = 'simple_contract_sp85'
}

const abTest = () => {
  const abTestData = ref<CampaignProps[]>([])
  const cookieData = ref<CampaignProps[]>([])

  const init = async () => {
    try {
      const abTestDataResponse: ResponseAbTest = await getAbTest()
      if (abTestDataResponse) {
        abTestData.value = abTestDataResponse.campaigns
      }
      cookieData.value = getAbTestCookie()
      const computedData = abTestData.value?.map((item) => {
        const matched = cookieData.value.find((cookieItem) => item.key === cookieItem.key)
        return matched || item
      }) || []

      if (computedData.length > 0) {
        setAbTestCookie(computedData)
        sendEvent()
      }

      return true
    } catch {
      return false
    }
  }

  const getGroupByKey = (targetKey: TestKey) => {
    const target = cookieData.value?.find((item) => item.key === targetKey)
    return target?.assign_group.toUpperCase() || ''
  }

  const checkGroup = (targetKey: TestKey, targetGroup: string) => {
    return getGroupByKey(targetKey) === targetGroup
  }

  const getAbTestCookie = () => {
    const cookieString = Cookies.get(COOKIE_NAME)
    return cookieString ? JSON.parse(cookieString) : []
  }

  const setAbTestCookie = (newData: CampaignProps[]) => {
    Cookies.set(COOKIE_NAME, JSON.stringify(newData))
    cookieData.value = newData
  }

  const sendEvent = () => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event:'logEvent',
        eventType:'experimentPlan',
        eventProperties: {
          experimentPlan: getAbTestCookie(),
        },
      })
    }
  }

  return {
    init,
    checkGroup,
  }
}

export default abTest()
